module.exports = __webpack_public_path__ + "img/1.9c761e66.png";